import firebase from 'firebase/app';

import FirebaseSetup from '../FirebaseSetup'

export default class StrikeTeamTagModel {
  constructor({ viewModel, tagId }) {
    this.viewModel = viewModel;
    this.tagId = tagId;
    this.tag = null;
    const firebaseSetup = new FirebaseSetup();
    this.currentUser = firebaseSetup.getCurrentUserDataInApp();
  }

  async fetchTagData() {
    if (this.tagId === null) return null;

    const db = firebase.firestore();
    const query = db.collection('tags').doc(this.tagId);
    this.tag = null;

    this.observerTag = query.onSnapshot(tagDoc => {
      this.tag = null;

      if (tagDoc.exists) {
        const data = tagDoc.data();
        const id = tagDoc.id;
        const full_data = { ...data, id };
        this.tag = full_data;
        this.updateDataSource();
      } else {
        this.tag = null;
        this.updateDataSource();
      }
    }, err => {
      this.tag = null;
      this.updateDataSource();
      console.log(`Tags query error: ${err}`);
    });
  }

  async updateDataSource() {
    this.viewModel.updatedTagDataSource(this.tag);
  }

  async updateTagWithData(data) {
    if (this.tagId && data) {
      const db = firebase.firestore();
      const query = db.collection('tags').doc(this.tagId);
      try {
        await query.set({
          ...data,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }, {
          merge: true
        });
      }
      catch(error){

      }
    } else {
      return null;
    }
  }
  
  stop() {
    if (this.observerTag) {
      this.observerTag();
      this.observerTag = null;
    }
  }

}
